import { init as initDemandCalls } from "./channels/demand_calls.js";

window.App || (window.App = {});
window.App.channels || (window.App.channels = {});
window.App.channels.initDemandCalls = initDemandCalls;
